if (!customElements.get("quick-add-modal")) {
  customElements.define(
    "quick-add-modal",
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.isLoading = false;

        this.addEventListener("product-info:loaded", ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        this.isLoading = false;
        const cartNotification =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = "";

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        // Prevent rapid clicks from opening multiple modals
        if (this.isLoading) return;
        this.isLoading = true;

        opener.setAttribute("aria-disabled", true);
        opener.classList.add("loading");
        opener.querySelector(".loading__spinner").classList.remove("hidden");

        fetch(opener.getAttribute("data-product-url"))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            const productElement = responseHTML.querySelector("product-info");

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(
              this.modalContent,
              productElement.outerHTML,
            );

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            // Show modal first so layout is computed
            super.show(opener);

            // THEN reset carousel and initialize dots after modal is visible and layout is stable
            requestAnimationFrame(() => {
              // Reset carousel scroll position after modal is shown
              this.resetCarouselScroll();

              const mediaGallery =
                this.modalContent.querySelector("media-gallery");
              if (
                mediaGallery &&
                typeof mediaGallery.initializeDots === "function"
              ) {
                // Force initialization now that modal is visible
                mediaGallery.initializeDots();
              }

              this.isLoading = false;
            });
          })
          .catch((error) => {
            console.error("Quick-add modal failed to load:", error);
            this.isLoading = false;
          })
          .finally(() => {
            opener.removeAttribute("aria-disabled");
            opener.classList.remove("loading");
            opener.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      preprocessHTML(productElement) {
        // Strip unused size classes from fetched HTML
        const productDiv = productElement.querySelector(".product");
        if (productDiv)
          productDiv.classList.remove(
            "product--large",
            "product--medium",
            "product--small",
          );

        // Remove duplicate mobile gallery wrapper to prevent doubled dots
        const mobileGallery = productElement.querySelector(
          "media-gallery.product__media-gallery--mobile",
        );
        if (mobileGallery) mobileGallery.remove();

        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith("color-") || classApplied === "gradient")
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.preallocateImageSpace(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute("data-update-url", "false");
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector(
          "pickup-availability",
        );
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector("product-modal");
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll("modal-dialog");
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(
          oldId,
          newId,
        );
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(
              attribute.name,
              attribute.value.replace(oldId, newId),
            );
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector(
          '[id^="Slider-Gallery"]',
        );
        if (!galleryList) return;

        galleryList.setAttribute("role", "presentation");
        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((li) => li.setAttribute("role", "presentation"));
      }

      preallocateImageSpace(productElement) {
        const mediaImages = productElement.querySelectorAll(
          ".product__media img",
        );
        if (!mediaImages.length) return;

        // Set explicit aspect ratio to prevent reflow when images load
        mediaImages.forEach((img) => {
          const width = img.getAttribute("width");
          const height = img.getAttribute("height");

          if (width && height) {
            img.style.aspectRatio = `${width} / ${height}`;
          } else {
            img.style.aspectRatio = "1 / 1";
          }
        });
      }

      resetCarouselScroll() {
        // Reset carousel to first slide after content injection
        const slider = this.modalContent.querySelector(".product__media-list");
        if (!slider) return;

        // Immediate scroll reset (no smooth behavior during modal opening)
        slider.scrollLeft = 0;

        // Also reset the slider component's state
        const sliderComponent =
          this.modalContent.querySelector("slider-component");
        if (sliderComponent && sliderComponent.slider) {
          sliderComponent.slider.scrollLeft = 0;
          // Trigger update to recalculate button states
          if (
            typeof sliderComponent.update === "function" &&
            sliderComponent.sliderItemsToShow?.length > 0
          ) {
            sliderComponent.update();
          }
        }
      }
    },
  );
}
